"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseChipsPrt = parseChipsPrt;
function parseChipsPrt(content) {
    const parts = new Map();
    let currentPart = null;
    let inPinSection = false;
    let currentPinName = null;
    for (const rawLine of content.split('\n')) {
        const line = rawLine.trim();
        if (line.length === 0) {
            continue;
        }
        const primitiveMatch = /^primitive\s+'([^']+)'\s*;?\s*$/i.exec(line);
        if (primitiveMatch !== null) {
            const name = primitiveMatch[1].toLowerCase();
            currentPart = { name, pinNumberByName: new Map() };
            parts.set(name, currentPart);
            inPinSection = false;
            currentPinName = null;
            continue;
        }
        if (/^end_primitive\s*;?\s*$/i.test(line)) {
            currentPart = null;
            inPinSection = false;
            currentPinName = null;
            continue;
        }
        if (currentPart === null) {
            continue;
        }
        if (/^pin\b/i.test(line)) {
            inPinSection = true;
            continue;
        }
        if (/^end_pin\s*;?\s*$/i.test(line)) {
            inPinSection = false;
            currentPinName = null;
            continue;
        }
        if (!inPinSection) {
            continue;
        }
        const pinHeaderMatch = /^'([^']+)'\s*:\s*$/.exec(line);
        if (pinHeaderMatch !== null) {
            currentPinName = pinHeaderMatch[1];
            continue;
        }
        if (currentPinName === null) {
            continue;
        }
        const pinNumberMatch = /^PIN_NUMBER\s*=\s*'\(?([^')]+)\)?'\s*;?\s*$/i.exec(line);
        if (pinNumberMatch !== null) {
            currentPart.pinNumberByName.set(currentPinName.toLowerCase(), pinNumberMatch[1]);
        }
    }
    return { parts };
}
//# sourceMappingURL=chipsPrtParser.js.map